module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-map-popup\">\n	<div class=\"title\">")
    ; __append(escapeFn( data.name ))
    ; __append("</div>\n	<div class=\"row\">")
    ; __append(escapeFn( data.addresstext ))
    ; __append("</div>\n\n	")
    ;  if (data.photos || data.plans || data.documents || data.cameras) { 
    ; __append("\n	<div class=\"row\">\n		<div><span class=\"gl-link-button objects-layer-on-info-click\" data-id=\"")
    ; __append(escapeFn( data.id ))
    ; __append("\">Дополнительно</span></div>\n	</div>\n	")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}